import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Emit, Prop, Vue, Watch } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import QuizQuestionLabel from "@/components/quiz/QuizQuestionLabel.vue";
let QuizSimpleTextQuestion = class QuizSimpleTextQuestion extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "question", void 0);
    _defineProperty(this, "questionCustomLabel", '');
    _defineProperty(this, "inputType", void 0);
    // can be text, textarea or other
    _defineProperty(this, "answer", void 0);
    _defineProperty(this, "answerLabel", void 0);
    _defineProperty(this, "isResultMode", void 0);
    _defineProperty(this, "realValue", "");
  }
  mounted() {
    this.realValue = this.answer;
  }
  onAnswerChange(answer) {
    this.realValue = answer;
    return this.realValue;
  }
  onChangePropValue() {
    this.realValue = this.answer;
  }
};
__decorate([Prop({
  required: true
})], QuizSimpleTextQuestion.prototype, "question", void 0);
__decorate([Prop], QuizSimpleTextQuestion.prototype, "questionCustomLabel", void 0);
__decorate([Prop({
  default: 'text'
})], QuizSimpleTextQuestion.prototype, "inputType", void 0);
__decorate([Prop({
  default: ''
})], QuizSimpleTextQuestion.prototype, "answer", void 0);
__decorate([Prop({
  default: ''
})], QuizSimpleTextQuestion.prototype, "answerLabel", void 0);
__decorate([Prop({
  default: false
})], QuizSimpleTextQuestion.prototype, "isResultMode", void 0);
__decorate([Emit("answerChange")], QuizSimpleTextQuestion.prototype, "onAnswerChange", null);
__decorate([Watch('answer')], QuizSimpleTextQuestion.prototype, "onChangePropValue", null);
QuizSimpleTextQuestion = __decorate([Component({
  components: {
    QuizQuestionLabel,
    WInput
  }
})], QuizSimpleTextQuestion);
export default QuizSimpleTextQuestion;